import type { AccountDto } from '@scala-watch/shared';

/** Seeded bootstrap org created on first super-admin sign-in; not a real tenant. */
export function isBootstrapDefaultAccount(
  account: Pick<AccountDto, 'slug' | 'name'> | null | undefined,
): boolean {
  return account?.slug === 'default' && account?.name === 'Default';
}
